import { render, staticRenderFns } from "./CompanyOnboardingView.vue?vue&type=template&id=dc466fd6&scoped=true"
import script from "./CompanyOnboardingView.vue?vue&type=script&lang=js"
export * from "./CompanyOnboardingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc466fd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc466fd6')) {
      api.createRecord('dc466fd6', component.options)
    } else {
      api.reload('dc466fd6', component.options)
    }
    module.hot.accept("./CompanyOnboardingView.vue?vue&type=template&id=dc466fd6&scoped=true", function () {
      api.rerender('dc466fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/CompanyOnboardingView.vue"
export default component.exports